import React, { useEffect, useRef, useState } from 'react'
import { Textarea } from '@/Components/ui/textarea'

const ResizingTextArea = ({value = '', handleOnChange}) => {
    const textareaRef = useRef(null)
   
    // const [value, setValue] = useState('')

    const resize = () => {
        const textarea = textareaRef.current
        if (textarea) {
            textarea.style.height = 'auto' // Reset first
            textarea.style.height = `${textarea.scrollHeight}px` // Grow to full content
        }
    }

    // Resize when value changes
    useEffect(() => {
        resize()
    }, [value])

    // Paste fix: allow content to paste first, then resize
    const handlePaste = () => {
        setTimeout(resize, 0)
    }

    return (
        <Textarea
            ref={textareaRef}
            rows={1}
            value={value}
            onChange={(e) => {
                console.log("hanldeonchange",e.target.value)
               handleOnChange(e.target.value)
            }}
            onInput={resize}
            onPaste={handlePaste}
            className="resize-none overflow-hidden outline-none ring-0 focus-visible:ring-0 border-none shadow-none w-full focus:shadow-none"
            style={{
                width: '100%',
                minHeight: '30px',
                overflow: 'hidden',
                resize: 'none',
                boxSizing: 'border-box',
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word',
            }}
            placeholder=""
        />
    )
}

export default ResizingTextArea
